define(function (require, exports, module) {
    /*
     * Saved previous loaded images here for faster retrieval.
     */
    var imgs = {};
    var SVG = 'SVG Document';

    module.exports = {
        /**
         * Dynamically load image with failure fallback. Passes back a promise
         * which will be resolved or rejected depending on image load result.
         * Saves previously laoded images in 'imgs' obejct cache.
         *
         * Passing 'true' as second argument to load will ignore cache and reload
         * image, replacing result in cache with new result.
         * 
         * @return {promise} resolved if image loads successfully, rejected in 
         *                   image load errors.         
         */
        load: function (src, clearFromCache) {

            if(imgs[src] && clearFromCache) {
                /*
                 * If image is cached in imgs hash, and clearFromCache
                 * is true, delete cached record and recreate.
                 */
                delete imgs[src];
            }
                
            return (imgs[src] = imgs[src] || new Promise(function (resolve, reject) {
                if (!src) {
                    reject({src: src, img: null});
                    return;
                }
                var img = document.createElement('img');
                img.onload = function () {
                    /*
                     * IE needs a naturalHeight check for images
                     * but, ie doesn't assign naturalHeight for svg.
                     * So check the mimeType.
                     */
                    if (img.naturalHeight || img.mimeType === SVG || img.complete) {
                        img.onload = img.onerror = null;
                        resolve({src: src, img: img});
                    } else {
                        img.onerror();
                    }
                };
                img.onerror = function () {
                    img.onload = img.onerror = null;
                    reject({src: src, img: img});
                };
                img.src = src;
            }));
        }
    };
});